<script>
import { defineComponent, computed, unref } from 'vue-demi'
// import { dateFormat } from '@aixuexi/tol-utils'
import store from '@/store'
import StudentTip from './studentTip.vue'
import TextTagNew from '@/components/TextTagNew.vue'
export default defineComponent({
  props: {
    itemData: {
      type: Object,
      default: () => ({
        groupName: '', // 小组名称
        studentNum: '', // 人数
        userName: '', // 老师名字
        beginTime: '', // 开课时间
        endTime: '', // 结束时间
        year: '', // 年份
        semester: '', // 学期
        classCycleStr: '', // 周期
        period: '', // 期次
        timeIntervalStr: '', // 时段
        sourceType: -1
      })
    },
    selectedItem: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, { emit }) {
    /**
     * @description 点击事件
     */
    const handleItemClick = () => {
      emit('click', props.itemData)
    }
    /**
     * @description 是否选中
     */
    const isSelect = computed(() => {
      // console.log('props.itemData.id', props.itemData)
      // console.log('props.selectedId', unref(props.selectedItem))
      if (!props.itemData || !props.selectedItem) return false
      return props.itemData.id === unref(props.selectedItem).id
    })
    // 周期
    const periodName = id => computed(() => {
      const { periodList } = store.state.common
      const period = periodList.filter(item => item.id === id)
      return period ? period[0].name : ''
    })
    return {
      handleItemClick,
      isSelect,
      periodName
    }
  },
  render() {
    const { year, semester, studentNum, period, classCycleStr, timeIntervalStr, itvCourseName, correctionNum, correctionDivisionNum, experience, sourceType = -1 } = this.itemData
    return <div class = {['group-item', { selected: this.isSelect }]} onclick={this.handleItemClick}>
      <span v-show={experience === 1} class="try-course">体验课</span>
      <div class="base-info">
        <div class="text">
          <span class="name">{this.itemData.groupName}</span>
          <span class="num">{studentNum + '人'}</span>
          <StudentTip groupId={ this.itemData.id } />
        </div>
      </div>
      <div class="date">
        {itvCourseName}
      </div>
      <div class="extra-info">
        { year > 0 && semester ? <span class="year item">{`${year + ' ' + semester} `}</span> : null}
        <span class="period item">{unref(this.periodName(period))}</span>
        <span class="class-cycle item">{classCycleStr}</span>
        <span class="time-interval item">{timeIntervalStr}</span>
      </div>
      <div v-show={sourceType !== 2} class="correct-info 111" style={{ color: correctionDivisionNum === 0 ? '#5DB748' : '#ec574c' }}>
        {`待批改${correctionNum}人（${correctionDivisionNum}份)`}
      </div>
      <TextTagNew v-show={sourceType === 2} class-name="yellow" words="课程升级Pro版" />
    </div>
  }
})
</script>
<style lang="less" scoped>
.group-item {
  padding: 8px;
  background: #F5F7F9;
  margin-bottom: 14px;
  position: relative;
  border: 1px solid transparent;
  .try-course {
    position:absolute;
    right: 0;
    top: 0;
    font-family: 'Microsoft YaHei UI';
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 18px;
    letter-spacing: 0.04em;
    color: #FFFFFF;
    background: #3262FD;
    border-bottom-left-radius: 4px;
    padding: 0 4px;
  }
  &.selected {
    border-color: #3262FD;
  }
  .base-info {
    display: flex;
    .text {
      flex: 1;
      .name {
        margin-right: 12px;
        font-size: 18px;
      }
      .num {
        margin-right: 12px;
      }
    }
  }
  .date {
    padding: 4px 0;
    color: #70788c;
  }
  .extra-info {
    font-size: 12px;
    color: #98A2B2;
    .item {
      padding-right: 12px;
    }
  }
  .correct-info {
    text-align: right;
    color: #FF5C5C;
  }
}
</style>
